import { useState } from 'react';
import css from './index.module.scss';
import EFPicture from 'elem/compCommon/EFPicture';

export default function OptionsPopUp({ callback }: any) {
    const [cartKey, setCartKey] = useState('2');

    return (
        <div className={`castCard-popup ${css['castCard-popup']}`}>
            <div className="castCard-popup-content">
                <header className="castCard-popup-header">
                    <span>Details</span>
                    <svg
                        className="header-close"
                        onClick={() => callback(false)}
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <path d="M6 5L19 18M19 5L6 18" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </header>
                <body className="castCard-popup-body">
                    <p className="castCard-cart">
                        <p className={`castCard-cart${cartKey === '1' ? '-active' : '-brn1'}`} onClick={() => setCartKey('1')}>
                            Canada Greener Homes Loan
                        </p>
                        <p className={`castCard-cart${cartKey === '2' ? '-active' : '-brn2'}`} onClick={() => setCartKey('2')}>
                            Toronto Home Energy Loan Program
                        </p>
                    </p>
                    {cartKey === '1' && (
                        <p className="castCard-desc">
                            Eligible Canadian homeowners can apply for an <span className="blue">interest-free loan of up to $40,000</span> to support
                            energy-efficient home upgrades, including solar panels, heat pumps, insulation, and battery storage systems, with repayment terms of
                            <span className="blue"> up to 10 years</span>. For more details, please visit the official website.
                        </p>
                    )}
                    {cartKey === '2' && (
                        <p className="castCard-desc">
                            Eligible Toronto homeowners can borrow up to
                            <span className="blue"> $125,000 </span>
                            for home energy upgrades, including rooftop solar PV panels and battery storage, with repayment terms of
                            <span className="blue"> up to 20 years</span>. For more details, go to the official website.
                        </p>
                    )}
                </body>
            </div>
        </div>
    );
}
